export default __webpack_public_path__ + "static/media/subMenu2.7a3138b3.svg";